<div mat-dialog-title class="markupRuleTitle">
  <h2>{{ formTitle }}</h2>
  <p>{{ formSubtitle }}</p>
</div>

<form class="markupRuleForm" [formGroup]="createForm" (ngSubmit)="save()">
  <mat-dialog-content class="markupRuleContent">
    <section class="markupRuleSection markupRuleRange">
      <div class="markupRuleSectionHead">
        <span class="markupRuleStep">1</span>
        <div>
          <h3>Закупочная цена</h3>
          <p>Правило сработает, когда закупка товара попадает в этот диапазон. Граница “до” считается включительно.</p>
        </div>
      </div>

      <div class="markupRuleGrid">
        <mat-form-field appearance="outline">
          <mat-label>Цена от, грн</mat-label>
          <input matInput type="number" formControlName="rangeStart" />
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="!isUnlimited">
          <mat-label>Цена до, грн</mat-label>
          <input matInput type="number" formControlName="rangeEnd" />
          <mat-hint>Для цен до 99,99 укажите 99,99</mat-hint>
        </mat-form-field>
      </div>

      <mat-slide-toggle [checked]="isUnlimited" (change)="toggleUnlimited($event.checked)">
        Нет верхней границы
      </mat-slide-toggle>

      <div class="markupRuleSummary">{{ rangeSummary }}</div>

      <div class="markupRuleWarning" *ngIf="rangeError">
        <mat-icon>warning</mat-icon>
        Конец диапазона не может быть меньше начала
      </div>

      <div class="markupRuleWarning" *ngIf="rangeEndMissing">
        <mat-icon>warning</mat-icon>
        Укажите конец диапазона или включите "Нет верхней границы"
      </div>
    </section>

    <section class="markupRuleSection markupRuleMarkup">
      <div class="markupRuleSectionHead">
        <span class="markupRuleStep">2</span>
        <div>
          <h3>Как считать продажную цену</h3>
          <p>Выберите процент от закупки или фиксированную сумму сверху.</p>
        </div>
      </div>

      <mat-button-toggle-group formControlName="type" class="markupTypeToggle">
        <mat-button-toggle [value]="markupType.PERCENT">Процент</mat-button-toggle>
        <mat-button-toggle [value]="markupType.FIXED">Сумма, грн</mat-button-toggle>
      </mat-button-toggle-group>

      <div class="markupRuleGrid">
        <mat-form-field appearance="outline">
          <mat-label>Размер наценки</mat-label>
          <input matInput type="number" formControlName="markup" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Округлять до, грн</mat-label>
          <input matInput type="number" formControlName="round" />
        </mat-form-field>
      </div>

      <div class="markupRuleHint">
        <span>{{ typeHelpText }}</span>
        <span>Округление 10 = итоговая цена будет кратна 10 грн.</span>
      </div>

      <div class="markupRuleWarning" *ngIf="roundError">
        <mat-icon>warning</mat-icon>
        Округление должно быть больше 0
      </div>
    </section>

    <section class="markupRuleSection markupRuleConditions">
      <div class="markupRuleSectionHead">
        <span class="markupRuleStep">3</span>
        <div>
          <h3>Для каких товаров</h3>
          <p>Оставьте папку и производителей пустыми, чтобы правило работало для всех товаров.</p>
        </div>
      </div>

      <div class="markupRuleConditionsGrid">
        <app-folder-selector [control]="folderControl"></app-folder-selector>
        <app-multi-selector [control]="brandsControl"></app-multi-selector>

        <mat-form-field appearance="outline">
          <mat-label>Приоритет правила</mat-label>
          <input matInput type="number" formControlName="priority" />
        </mat-form-field>
      </div>

      <div class="markupRuleSummary">{{ conditionsSummary }}</div>
      <div class="markupRuleHint">
        Чем больше приоритет, тем сильнее правило при пересечении с другими правилами.
      </div>
    </section>

    <section class="markupRulePreview">
      <div class="markupRuleSectionHead">
        <span class="markupRuleStep">4</span>
        <div>
          <h3>Проверка</h3>
          <p>Показывает цену продажи по текущим настройкам формы.</p>
        </div>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Закупочная цена для проверки</mat-label>
        <input matInput type="number" [formControl]="previewPrice" />
      </mat-form-field>

      <div class="markupRulePreviewResult">
        <span>Цена продажи</span>
        <strong>{{ previewSaleText }}</strong>
        <small>{{ previewCalculationText }}</small>
        <div
          class="markupRuleRangeNotice"
          [class.markupRuleRangeNotice_success]="previewRangeState === 'success'"
          [class.markupRuleRangeNotice_warning]="previewRangeState === 'warning'"
        >
          <mat-icon>{{ previewRangeState === 'success' ? 'check_circle' : 'info' }}</mat-icon>
          <span>{{ previewRangeNoticeText }}</span>
        </div>
      </div>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close [disabled]="loading">Отмена</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="loading || createForm.invalid || rangeError || roundError || rangeEndMissing"
    >
      Сохранить
    </button>
  </mat-dialog-actions>
</form>
